<script lang="ts">
    import tngLogo from '../assets/tng.svg';
</script>

<footer>
    <a class="link" href="https://tngtech.com">
        <img class="logo" src="{tngLogo}" alt="TNG Technology Consulting GmbH" />
    </a>
</footer>

<style>
    footer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 3rem;
        box-sizing: border-box;
        font-size: 1.8rem;
        text-align: center;
        background-color: var(--bs-dark) !important;
    }

    .logo {
        height: 1.5rem;
    }

    .link:link, .link:visited {
        color: var(--primary-foreground)
    }
</style>
